var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import CreateCompanyValueMutation from "@irati/companyvalues/apollo/mutation/Create";
import EditCompanyValueMutation from "@irati/companyvalues/apollo/mutation/Edit";
import authentication from "@irati/auth";
import { companyValuesTracking } from "@irati-tracking/admin";
import { CompanyValuesForm } from "./Form";
var CreateCompanyValue = /** @class */ (function (_super) {
    __extends(CreateCompanyValue, _super);
    function CreateCompanyValue(props) {
        var _this = _super.call(this, props) || this;
        _this.onChangeIcon = function (icon) {
            _this.setState({ icon: icon });
        };
        _this.onChange = function (property, value) {
            var _a;
            _this.setState((_a = {}, _a[property] = value, _a));
        };
        _this.submit = function (onSubmit, value) {
            var uuid = _this.state.uuid;
            if (uuid) {
                companyValuesTracking.editCompanyValue(value, uuid);
            }
            else {
                companyValuesTracking.createCompanyValue(value);
            }
            onSubmit(value);
        };
        var _a = props.companyValue || {}, _b = _a.name, name = _b === void 0 ? undefined : _b, _c = _a.desc, desc = _c === void 0 ? undefined : _c, _d = _a.tag, tag = _d === void 0 ? undefined : _d, _e = _a.icon, icon = _e === void 0 ? undefined : _e, _f = _a.uuid, uuid = _f === void 0 ? undefined : _f;
        _this.state = {
            desc: desc,
            name: name,
            tag: tag,
            icon: icon,
            uuid: uuid
        };
        return _this;
    }
    CreateCompanyValue.prototype.componentDidMount = function () {
        if (this.state.uuid) {
            companyValuesTracking.startEditCompanyValue();
        }
        else {
            companyValuesTracking.startCreateCompanyValue();
        }
    };
    CreateCompanyValue.prototype.render = function () {
        var _this = this;
        var _a = this.props, onSuccess = _a.onSuccess, companyValue = _a.companyValue;
        var tenantId = authentication.userTenant().uuid;
        var buttonText = companyValue ? "admin.companyValues.edit.button" : "admin.companyValues.create.button";
        var headerText = companyValue ? "admin.companyValues.edit.header" : "admin.companyValues.create.header";
        var MutationComponent = companyValue ? EditCompanyValueMutation : CreateCompanyValueMutation;
        return (React.createElement(MutationComponent, { companyValue: this.state, onCompleted: onSuccess, tenantId: tenantId }, function (onSubmit, apolloState) { return (React.createElement(CompanyValuesForm, { apolloState: apolloState, buttonText: buttonText, companyValue: _this.state, headerText: headerText, onChange: _this.onChange, onChangeIcon: _this.onChangeIcon, onSubmit: function (value) { return _this.submit(onSubmit, value); } })); }));
    };
    return CreateCompanyValue;
}(Component));
export default CreateCompanyValue;
